import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { Hyperlink } from '../../../../../components/Hyperlink';
import {
  buildUrlWithParameters,
  isUrlInternal,
} from '../../../../../utils/url-utils/urlUtils';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import styles from './search_commentary_snippet_item.module.scss';
import { ResultsType } from '../../../../state/reducers/results.types';
import { trackCommentary } from '../../../../../commentary/commentary.api';

type Props = {
  commentary: NonNullable<ResultsType['snippets']['commentaries']>[0];
  index: number;
};

export class SearchCommentarySnippetItem extends React.Component<Props> {
  onTitleClicked = () => {
    const { commentary, index } = this.props;
    const source = 'commentaries_snippet';
    doctrineAnalytics('Search CommentClicked', {
      source,
      reportOriginalQueryKey: true,
      position: index,
      commentaire_id: commentary.commentaireId,
      url: commentary.url,
    });
    trackCommentary(commentary.url, source, {
      doc_id: commentary.commentaireId,
      position: index,
    });
  };

  render() {
    const { commentary } = this.props;
    const { originalDate } = commentary;
    const enhancedUrl = isUrlInternal(commentary.url)
      ? buildUrlWithParameters(commentary.url, {
          source: 'commentary-snippet',
        })
      : commentary.url;
    return (
      <div className={styles.container}>
        <Hyperlink
          className={styles.title}
          href={enhancedUrl}
          onClick={this.onTitleClicked}
        >
          <span dangerouslySetInnerHTML={{ __html: commentary.title }} />
        </Hyperlink>
        <div className={styles.subtitle}>
          {commentary.author && (
            <span
              className={styles.author}
              dangerouslySetInnerHTML={{ __html: commentary.author }}
            />
          )}

          {commentary.niceSource && (
            <span className={styles.source}>
              {!!commentary.author && (
                <span className={styles.separator}>–</span>
              )}
              <span
                dangerouslySetInnerHTML={{ __html: commentary.niceSource }}
              />
            </span>
          )}

          {originalDate && (
            <span className={styles.date}>
              {(!!commentary.author || !!commentary.niceSource) && (
                <span className={styles.separator}>·</span>
              )}
              {commentary.originalDate &&
                formatDateFromNow(commentary.originalDate)}
            </span>
          )}
        </div>
        {commentary.textShort && (
          <div className={styles.text}>
            <span dangerouslySetInnerHTML={{ __html: commentary.textShort }} />
            <Hyperlink
              href={commentary.url}
              target="_blank"
              className={styles.more}
              onClick={this.onTitleClicked}
            >
              <FormattedMessage id="search/components/search-snippets/main/commentary/SearchCommentarySnippetItem.tsx/1" />
            </Hyperlink>
          </div>
        )}
      </div>
    );
  }
}
